// Function loadJudgesContainerBlock loads the JudgesContainerBlock class by dynamically importing the js on demand if needed

export function loadJudgesContainerBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-judges-container-block-chunk" */ '../widgets/judgesContainerBlock').then(wg => {

		const { JudgesContainerBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="JudgesContainerBlock"]');

		if(!$wg) {
			// console.info('JudgesContainerBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="JudgesContainerBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new JudgesContainerBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new JudgesContainerBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the JudgesContainerBlock widget');

}
